import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import MyDashboard from "./pages/MyDashboard";
import Schedule from "./pages/Schedule";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Shoots from "./pages/Shoots";
import Team from "./pages/Team";
import Attendance from "./pages/Attendance";
import Backlog from "./pages/Backlog";
import Graphics from "./pages/Graphics";
import Reports from "./pages/Reports";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

function RoleRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (user.role === "client") return <Navigate to="/clients" replace />;
  return <Navigate to="/dashboard" replace />;
}

function RoleDashboard() {
  const { user } = useAuth();
  if (user?.role === "admin") return <Dashboard />;
  if (user?.role === "editor" || user?.role === "smm") return <MyDashboard />;
  return <Navigate to="/clients" replace />;
}

function AppRouter() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/change-password" element={
        <ProtectedRoute>
          <ChangePassword />
        </ProtectedRoute>
      } />
      <Route path="/" element={<RoleRedirect />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={
          <ProtectedRoute allowedRoles={["admin", "editor", "smm"]}>
            <RoleDashboard />
          </ProtectedRoute>
        } />
        <Route path="/schedule" element={
          <ProtectedRoute allowedRoles={["admin", "editor", "smm"]}>
            <Schedule />
          </ProtectedRoute>
        } />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<ClientDetail />} />
        <Route path="/shoots" element={
          <ProtectedRoute allowedRoles={["admin", "editor", "smm"]}>
            <Shoots />
          </ProtectedRoute>
        } />
        <Route path="/attendance" element={
          <ProtectedRoute allowedRoles={["admin", "editor", "smm"]}>
            <Attendance />
          </ProtectedRoute>
        } />
        <Route path="/graphics" element={
          <ProtectedRoute allowedRoles={["admin", "editor", "smm", "client"]}>
            <Graphics />
          </ProtectedRoute>
        } />
        <Route path="/backlog" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Backlog />
          </ProtectedRoute>
        } />
        <Route path="/reports" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Reports />
          </ProtectedRoute>
        } />
        <Route path="/team" element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Team />
          </ProtectedRoute>
        } />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
